<template>
  <b-dropdown
    :class="buttonStyleClasses"
    :size="sizeComputed"
    :variant="variantComputed"
    :disabled="disabled"
    :block="block"
    split
    :offset="offset"
    toggle-class="dropdown-toggle-custom"
    @click="clickCallback"
  >
    <template #button-content>
      <slot></slot>
    </template>

    <slot name="actions"></slot>
  </b-dropdown>
</template>

<script>
import { isObjectEmpty } from '../../core/helpers/globalMethods';

const VARIANTS = [
  'primary',
  'secondary',
  'success',
  'warning',
  'danger',
  'info',
  'light',
  'dark',
  'link',
  'hover',
  'custom-link'
];

const SIZES = {
  'small': 'sm',
  'medium': '',
  'large': 'lg',
};

export default {
  name: 'StExpandableButton',
  props: {
    notRendered: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'medium',
    },
    block: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Number,
      default: 0,
    },
    // Set a custom css class to the button
    customClass: String,
    // Defines a callback function which can be used to update parent state on change event
    callback: Function,
    // Defines a store action as string which can be used to update parent state on change event
    callbackAction: String,
    // Defines params for callback function or callback action
    callbackParams: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
        default: 'primary',
    },
    spinner: {
      type: Boolean,
      default: false,
    },
    to: String,
  },
  computed: {
    buttonStyleClasses() {
      const classes = ['st-expandable-button'];
      if (this.customClass) {
        classes.push(this.customClass);
      }
      if (!this.disabled && this.variant === 'light') {
        classes.push('st-btn-text-primary');
      }
      if (this.variant === 'link') {
        classes.push('st-btn-custom-link');
      }
      if (this.spinner) {
        classes.push('spinner spinner-right');
      }
      return classes;
    },
    variantComputed() {
      const variant = VARIANTS.includes(this.variant) ? this.variant : 'primary';
      if (this.outline) {
        return `outline-${variant}`;
      }
      return variant;
    },
    sizeComputed() {
      const size = Object.keys(SIZES).includes(this.size) ? this.size : 'default';
      return SIZES[size];
    },
  },
  methods: {
    clickCallback() {
      if (this.spinner) {
        return;
      }

      if (this.callback) {
        if (!isObjectEmpty(this.callbackParams)) {
          this.callback(this.callbackParams);
        } else {
          this.callback();
      }

      if (this.callbackAction) {
        this.$store.dispatch(this.callbackAction, this.callbackParams);
      }
      }
    }
  },
};
</script>